import {
  IAddress,
  UpdateAddressParams,
  UpdateAddressParamsWithCountry,
} from "@/core/types/address";

/**
 * Returns the address string, or null if the address is null
 * @param address
 * @returns
 */
export const getAddressString = (address: IAddress | null) => {
  if (!address) return null;

  const parts = [
    address.line_one,
    address.line_two,
    address.city,
    [address.state, address.zip_code].filter(Boolean).join(" "),
  ].filter(Boolean);

  return parts.join(", ");
};

/**
 * Returns the address attributes with the country added, or null if all fields are empty
 * @param addressParams
 * @returns
 */
export const getAddressFromUpdateAddressParams = (
  addressParams?: UpdateAddressParams | null,
): UpdateAddressParamsWithCountry | null => {
  if (!addressParams) return null;

  //Check all fields are empty
  const hasEmptyFields =
    !addressParams?.line_one &&
    !addressParams?.line_two &&
    !addressParams?.city &&
    !addressParams?.state &&
    !addressParams?.zip_code;

  if (hasEmptyFields) return null;

  return { ...addressParams, country: "USA" };
};

/**
 * Returns the address attributes if the address is new, otherwise returns undefined
 * @param addressAttributes
 * @param existingAddress
 * @returns
 */
export const getAddressAttributesIfNewAddress = (
  addressAttributes: UpdateAddressParams,
  existingAddress?: IAddress | null,
) => {
  if (
    existingAddress?.line_one === addressAttributes.line_one &&
    existingAddress?.line_two === addressAttributes.line_two &&
    existingAddress?.city === addressAttributes.city &&
    existingAddress?.state === addressAttributes.state &&
    existingAddress?.zip_code === addressAttributes.zip_code
  ) {
    return undefined;
  }

  return getAddressFromUpdateAddressParams(addressAttributes);
};
